(() => {
  if (window.waveCartLayoutReady) return;
  window.waveCartLayoutReady = true;
  let queued = false;
  function arrange() {
    queued = false;
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      const items = drawer.querySelector('cart-drawer-items');
      if (!items) return;
      drawer.querySelectorAll('.drawer__footer [data-essential-upsell-funnel-id]').forEach(offer => {
        let mount = offer;
        while (mount.parentElement && mount.parentElement !== drawer.querySelector('.drawer__footer') && !mount.parentElement.querySelector('.totals, .cart__ctas')) mount = mount.parentElement;
        let slot = items.querySelector('.wave-cart-offers');
        if (!slot) { slot = document.createElement('div'); slot.className = 'wave-cart-offers'; items.appendChild(slot); }
        slot.appendChild(mount);
      });
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(arrange); } }
  function init() {
    document.querySelectorAll('cart-drawer').forEach(drawer => new MutationObserver(schedule).observe(drawer, {childList:true,subtree:true}));
    arrange();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
